import { render, staticRenderFns } from "./edit-role-dialog.vue?vue&type=template&id=1e3d28f0&scoped=true"
import script from "./edit-role-dialog.vue?vue&type=script&lang=ts"
export * from "./edit-role-dialog.vue?vue&type=script&lang=ts"
import style0 from "./edit-role-dialog.vue?vue&type=style&index=0&id=1e3d28f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3d28f0",
  null
  
)

export default component.exports